import cancelPolicy from "../../assets/images/cancelPolicy.svg";
import refreshIcon from "../../assets/images/refresh-dark.svg";

// Personal Accident-specific action type constants
export const CANCEL_POLICY_PERSONAL_ACCIDENT = "CANCEL_POLICY_PERSONAL_ACCIDENT";

// Personal Accident Policy Overview Data
export const personalAccidentPolicyOverview = {
  policyInfo: {
    policy_label: "Your Personal Accident Policy",
    policy_label_ar: "وثيقة تأمين الحوادث الشخصية",
    status: "Active",
    status_ar: "نشيط",
    planName: "Personal Accident Insurance",
    planName_ar: "سياسة التأمين على الحوادث الشخصية",
    policyNumber: "",
    date: {
      startDate: "",
      endDate: "",
    },
    btn: {
      icon: refreshIcon,
      btn_lable_en: "Renew Policy",
      btn_lable_ar: "تجديد الوثيقة",
    },
  },
};

// Personal Accident Coverage and Benefits
export const personalAccidentCoverageAndBenefits = {
  benefits: [
    {
      id: 1,
      label_en: "Accidental Death Coverage",
      label_ar: "تغطية الوفاة العرضية",
      description_en: "Financial protection in case of accidental death",
      description_ar: "حماية مالية في حالة الوفاة العرضية",
    },
    {
      id: 2,
      label_en: "Disability Benefits",
      label_ar: "مزايا العجز",
      description_en: "Compensation for permanent or temporary disability",
      description_ar: "تعويض عن العجز الدائم أو المؤقت",
    },
    {
      id: 3,
      label_en: "Medical Expense Coverage",
      label_ar: "تغطية المصاريف الطبية",
      description_en: "Coverage for medical expenses due to accidents",
      description_ar: "تغطية المصاريف الطبية بسبب الحوادث",
    },
    {
      id: 4,
      label_en: "Hospital Daily Allowance",
      label_ar: "بدل يومي في المستشفى",
      description_en: "Daily compensation during hospitalization",
      description_ar: "تعويض يومي أثناء الإقامة في المستشفى",
    },
    {
      id: 5,
      label_en: "Fracture Benefits",
      label_ar: "مزايا الكسور",
      description_en: "Additional benefits for bone fractures",
      description_ar: "مزايا إضافية لكسور العظام",
    },
  ],
};

// Personal Accident Manage Policy Cards - Only Cancel Policy
export const managePersonalAccidentPolicy = {
  cards: [
    {
      id: "cancel-policy",
      value: "Cancel Policy",
      value_ar: "إلغاء السياسة",
      description_en: "Submit a request to cancel your personal accident policy",
      description_ar: "تقديم طلب لإلغاء وثيقة تأمين الحوادث الشخصية",
      icon: cancelPolicy,
      route: "/personal-accident/endorsements/cancel-policy",
      type: CANCEL_POLICY_PERSONAL_ACCIDENT,
    },
  ],
};

// Cancel Policy Card Data
export const CANCEL_POLICY_PERSONAL_ACCIDENT_CARD = {
  id: "cancel-policy",
  value: "Cancel Policy",
  value_ar: "إلغاء السياسة",
  description_en: "Submit a request to cancel your personal accident insurance policy",
  description_ar: "تقديم طلب لإلغاء وثيقة تأمين الحوادث الشخصية",
  icon: cancelPolicy,
  route: "/personal-accident/endorsements/cancel-policy",
  type: CANCEL_POLICY_PERSONAL_ACCIDENT,
};

// Filter function for Personal Accident cards based on policy status
export const getFilteredPersonalAccidentCards = (policyHeader) => {
  const cards = [];

  // Only show cancel policy if policy is active
  const policyStatusCode = policyHeader?.StatusCode;
  const isPolicyActive = policyStatusCode === "05";

  if (isPolicyActive) {
    cards.push(CANCEL_POLICY_PERSONAL_ACCIDENT_CARD);
  }

  return cards;
};